import { useState, useEffect } from "react";
import { doc, updateDoc } from "firebase/firestore";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import "./profile.css";
import avatar from "../../assets/avatar.png";
import BannderDeciderContainer from "./BannderDeciderContainer";
import init from "../../firebase";
import { useUserAuth } from "../../context/UserAuthContext";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import enquire from "../../assets/icons/enquire.png";
import details from "../../assets/icons/details.png";
import updateIcon from "../../assets/update.png";
import "../businessAnalysis/businessAnalysis.css";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { MdCloudUpload } from "react-icons/md";
import axios from "axios";

const Profile = () => {
  const { user: auth, CityNameFinder, user, language, token } = useUserAuth();
  const merchant_id = user?.uid;
  const base_url = import.meta.env.VITE_LOCAL_BASE_URL;

  // State
  const [loading, setLoading] = useState(true);
  const [merchant, setMerchant] = useState(null);
  const [image, setImage] = useState(null);
  const [fileName, setFileName] = useState("No selected file");
  const [progresspercent, setProgresspercent] = useState(0);
  const [preferences, setPreferences] = useState([]);
  // console.log('preference', merchant);

  const [editFormData, setEditFormData] = useState({ business_name: "" });
  const [destination_id, set_destination_id] = useState("");
  const [corporate_id, set_corporate_id] = useState("");
  const [corporate_sub_cat_id, set_corporate_sub_cat_id] = useState("");
  const [destination_sub_cat_id, set_destination_sub_cat_id] = useState();

  // Modal states
  const [showNameModal, setShowNameModal] = useState(false);
  const [showDestinationModal, setShowDestinationModal] = useState(false);
  const [showCorporateModal, setShowCorporateModal] = useState(false);
  const [showCategoryModal, setShowCategoryModal] = useState(false);

  // Categories data
  const categories = [
    { id: "52vn6kWKmCCUGk6DqKfM", name: "Lawn" },
    { id: "8x7UFtmckFjIuWUA4oaj", name: "Hotel" },
    { id: "Gsj5h6LfHMqWKbbWDdeh", name: "Banquet Halls" },
    { id: "WgPT5AjEU6y3lnpxxkIq", name: "Resorts" },
    { id: "XfRVyejjN7EPxxVmGNA2", name: "Birthday Venues" },
  ];
  const categoriesforCorporate = [
    { id: "iAfD04pQNNJjvBLA4jeF", name: "Corporate Events" },
    { id: "t5CjPhRmhZAgJ5ZxXKlQ", name: "Event Planner" }
  ];

  const filteredCategory = merchant?.category_id === 'trvwyuvRqNTuZQh8KNbi' ? categories : categoriesforCorporate
  // Dashboard boxes data

const filterd_path =
  merchant?.category_id === "trvwyuvRqNTuZQh8KNbi"
    ? "/dashboard/venue-previous-work"
    : "/dashboard/previous-work";
const [dashboardBoxes, setDashboardBoxes] = useState([]);
useEffect(() => {
  setDashboardBoxes([
    {
      title: "Basic Details",
      hindiTitle: "सामान्य जानकारी",
      url: details,
      href: "/dashboard/basic-detail",
    },
    {
      title: "Add Business Photos",
      hindiTitle: "व्यवसाय का फोटो डालें",
      url: enquire,
      href: filterd_path,
    },
    {
      title: "Things To Know",
      hindiTitle: "जानने योग्य जानकारी",
      url: enquire,
      href: "/dashboard/thinks-to-know",
    },
    {
      title: "Products/Services",
      hindiTitle: "वस्तु/सर्विसेज",
      url: enquire,
      href: "/dashboard/add-product",
    },
     {
      title: "Business Address",
      hindiTitle: "वव्यावसायिक पता जोड़ें",
      url: enquire,
      href: "/dashboard/working-address-list",
    },
  ]);
}, [filterd_path]);
  // Helper functions
  const convertToSlug = (title) => {
    return title
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^a-z0-9-]/g, "")
      .replace(/-+/g, "-")
      .replace(/^-|-$/g, "");
  };

  // API Handlers
  const fetchMerchantData = async () => {
    if (!merchant_id) return;
    setLoading(true);
    try {
      const res = await axios.get(`${base_url}/api/v1/users/id/${merchant_id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });
      setMerchant(res.data.data);
      setImage(res.data.data?.profile_picture);
      setPreferences(res.data?.data.preferences || []);
      set_destination_id(res.data.data?.destination_id || "");
      set_destination_sub_cat_id(res.data.data?.destination_sub_cat_id || "");
      set_corporate_id(res.data.data?.corporate_id || "");
      set_corporate_sub_cat_id(res.data.data?.corporate_sub_cat_id || "");
    } catch (error) {
      console.error("Error fetching merchant data:", error);
      toast.error("Failed to load profile data");
    } finally {
      setLoading(false);
    }
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setImage(URL.createObjectURL(file));
    setFileName(file.name);

    const formData = new FormData();
    formData.append("profile_picture", file);

    try {
      await axios.post(
        `${base_url}/api/v1/profile-picture/image-upload/${merchant_id}`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            setProgresspercent(percentCompleted);
          },
        }
      );
      toast.success("Profile picture updated successfully");
    } catch (error) {
      console.error("Upload failed:", error);
      toast.error("Failed to update profile picture");
    }
  };

  const updateBusinessName = async () => {
    const { business_name } = editFormData;
    if (!business_name.trim()) {
      toast.error("Business name cannot be empty");
      return;
    }

    try {
      const city_name = await CityNameFinder(merchant.vendorProfile.city_id);
      const citySlug = convertToSlug(city_name);
      const businessSlug = convertToSlug(business_name);
      const finalSlug = `${businessSlug}-${citySlug}`;

      await updateDoc(doc(init.db, "merchants", merchant_id), {
        business_name,
        slug: finalSlug,
      });

      setEditFormData({ business_name: "" });
      setShowNameModal(false);
      fetchMerchantData();
      toast.success("Business name updated successfully");
    } catch (err) {
      console.error("Error updating business name:", err);
      toast.error("Failed to update business name");
    }
  };

  const updateDestination = async () => {
    try {
      await axios.put(`${base_url}/api/v1/vendors/destination/${merchant_id}`,
        {
          destination_id,
          destination_sub_cat_id,
        }
      );
      setShowDestinationModal(false);
      toast.info(
        "Your request is under process. Our team will shortly connect with you."
      );
    } catch (err) {
      console.error("Error updating destination:", err);
      toast.error("Failed to update destination");
    }
  };
  const updateCorporate = async () => {
    try {
      await axios.put(`${base_url}/api/v1/vendors/corporate/${merchant_id}`,
        {
          corporate_id,
          corporate_sub_cat_id,
        }
      );
      setShowCorporateModal(false);
      toast.info(
        "Your request is under process. Our team will shortly connect with you."
      );
    } catch (err) {
      console.error("Error updating destination:", err);
      toast.error("Failed to update destination");
    }
  };

  const updateCategories = async () => {
    try {
      await axios.put(`${base_url}/api/v1/vendors/preferences/${merchant_id}`, {
        preferences,
      });
      setShowCategoryModal(false);
      toast.success("Categories updated successfully");
    } catch (err) {
      console.error("Error updating categories:", err);
      toast.error("Failed to update categories");
    }
  };

  // Effects
  useEffect(() => {
    if(!merchant_id) return
    fetchMerchantData();
  }, [merchant_id]);

  return (
    <div className="page-wrapper">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body">
                {loading ? (
                  <Skeleton count={5} height={50} />
                ) : merchant ? (
                  <div className="profileHeader">
                    <div className="card">
                      <div className="card-header imgBannerParent bg-white m-0 p-0">
                        <BannderDeciderContainer
                          subCatId={merchant?.sub_category_id}
                        />
                      </div>
                      <div className="card-body imgProfileParent">
                        <form onClick={() => document.querySelector(".input-field").click()}>
                          <input
                            type="file"
                            accept="image/*"
                            className="input-field"
                            hidden
                            onChange={handleImageUpload}
                          />
                          <div className="position-relative">
                            {image ? (
                              <img
                                src={image}
                                width={180}
                                height={180}
                                alt="Profile"
                                style={{ objectFit: "contain" }}
                              />
                            ) : (
                              <img src={avatar} className="profileImages" alt="Profile" />
                            )}
                            <div className="position-absolute" style={{ bottom: '15px', right: '25px', zIndex: 10 }}>
                              <MdCloudUpload color="#1475cf" size={30} />
                            </div>
                          </div>
                        </form>
                      </div>
                      <div className="d-flex justify-content-center">
                        <h1 style={{ fontWeight: "bold", color: "#41B0FA" }}
                          className="business-name">
                          {merchant?.business_name}
                        </h1>
                      </div>

                      <div className="card-body">
                        <div className="row">
                          {dashboardBoxes.map((box, index) => (
                            <div className="col-md-3 col-6" key={index}>
                              <Link to={box.href}>
                                <div className="p-10 text-center total_card shadow-sm">
                                  <div className="data d-flex justify-content-center">
                                    <img
                                      src={box.url}
                                      className="dash_icon"
                                      alt=""
                                      style={{
                                        height: "50px",
                                        width: "50px",
                                        objectFit: "contain",
                                      }}
                                    />
                                  </div>
                                  <p
                                    className=" p-2"
                                    style={{
                                      fontWeight: "600",
                                      fontSize: "15px",
                                      color: "#000",
                                    }}
                                  >
                                    {language === "en" ? box.title : box.hindiTitle}
                                  </p>
                                </div>
                              </Link>
                            </div>
                          ))}

                          {merchant?.category_id === "trvwyuvRqNTuZQh8KNbi" && (
                            <>
                              <div className="col-md-3 col-6">
                                <div
                                  className="p-10 text-center total_card shadow-sm"
                                  onClick={() => setShowDestinationModal(true)}
                                >
                                  <div className="data d-flex justify-content-center">
                                    <img
                                      src={updateIcon}
                                      className="dash_icon"
                                      alt=""
                                      style={{
                                        height: "50px",
                                        width: "50px",
                                        objectFit: "contain",
                                      }}
                                    />
                                  </div>
                                  <p
                                    className=" p-2"
                                    style={{
                                      fontWeight: "600",
                                      fontSize: "15px",
                                      color: "#000",
                                    }}
                                  >Update Destination</p>
                                </div>
                              </div>
                              <div className="col-md-3 col-6">
                                <div
                                  className="p-10 text-center total_card shadow-sm"
                                  onClick={() => setShowCategoryModal(true)}
                                >
                                  <div className="data d-flex justify-content-center">
                                    <img
                                      src={updateIcon}
                                      className="dash_icon"
                                      alt=""
                                      style={{
                                        height: "50px",
                                        width: "50px",
                                        objectFit: "contain",
                                      }}
                                    />
                                  </div>
                                  <p
                                    className=" p-2"
                                    style={{
                                      fontWeight: "600",
                                      fontSize: "15px",
                                      color: "#000",
                                    }}
                                  >Select Your Category</p>
                                </div>
                              </div>
                            </>
                          )}
                          {
                            (merchant?.sub_category_id === "t5CjPhRmhZAgJ5ZxXKlQ" || merchant?.category_id === "eQzhKP8UvvGBgfrDRFr4") && (
                              <div className="col-md-3 col-6">
                                <div
                                  className="p-10 text-center total_card shadow-sm"
                                  onClick={() => setShowCorporateModal(true)}
                                >
                                  <div className="data d-flex justify-content-center">
                                    <img
                                      src={updateIcon}
                                      className="dash_icon"
                                      alt=""
                                      style={{
                                        height: "50px",
                                        width: "50px",
                                        objectFit: "contain",
                                      }}
                                    />
                                  </div>
                                  <p
                                    className=" p-2"
                                    style={{
                                      fontWeight: "600",
                                      fontSize: "15px",
                                      color: "#000",
                                    }}
                                  >Update Category</p>
                                </div>
                              </div>
                            )
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div>No merchant data found</div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Business Name Modal */}
        <Modal
          show={showNameModal}
          onHide={() => setShowNameModal(false)}
          centered
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title>Update Business Name</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="form-group">
              <input
                type="text"
                className="form-control"
                name="business_name"
                value={editFormData.business_name}
                onChange={(e) =>
                  setEditFormData({ ...editFormData, business_name: e.target.value })
                }
                placeholder="Enter business name"
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowNameModal(false)}>
              Cancel
            </Button>
            <Button variant="primary" onClick={updateBusinessName}>
              Update
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Destination Modal */}
        <Modal
          show={showCorporateModal}
          onHide={() => setShowCorporateModal(false)}
          centered
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title>Select Your Category</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="form-group">
              <label>Select Your Category</label>
              <select
                className="form-control"
                value={corporate_id}
                onChange={(e) => set_corporate_id(e.target.value)}
              >
                <option value="">No</option>
                {
                  merchant?.category_id === "lIctLmJMzKGyp9taXkFM"
                    ?
                    <option value="eQzhKP8UvvGBgfrDRFr4">Yes</option>
                    :
                    <option value="lIctLmJMzKGyp9taXkFM">Yes</option>

                }
              </select>
            </div>

            {(corporate_id || merchant?.corporate_sub_cat_id) && (
              <div className="form-group mt-3">
                <label>category</label>
                <select
                  className="form-control"
                  value={corporate_sub_cat_id}
                  onChange={(e) => set_corporate_sub_cat_id(e.target.value)}
                >
                  <option value="">Select Category</option>
                  {
                    merchant?.category_id === "lIctLmJMzKGyp9taXkFM"
                      ?
                      <option value="iAfD04pQNNJjvBLA4jeF" >Corporate Events</option>
                      :
                      <option value="t5CjPhRmhZAgJ5ZxXKlQ">Event Planners</option>
                  }
                </select>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowCorporateModal(false)}>
              Cancel
            </Button>
            <Button variant="primary" onClick={updateCorporate}>
              Update
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={showDestinationModal}
          onHide={() => setShowDestinationModal(false)}
          centered
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title>Select Destination</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="form-group">
              <label>Do you provide Destination Wedding?</label>
              <select
                className="form-control"
                value={destination_id}
                onChange={(e) => set_destination_id(e.target.value)}
              >
                <option value="">No</option>
                <option value="TwtVyXeU6ZlwN9HWtSdj">Yes</option>
              </select>
            </div>

            {destination_id && (
              <div className="form-group mt-3">
                <label>Venue Type</label>
                <select
                  className="form-control"
                  value={destination_sub_cat_id}
                  onChange={(e) => set_destination_sub_cat_id(e.target.value)}
                >
                  <option value="">Select Places</option>
                  <option value="HT33vunkJlPeg1kiP7K2">Hill Places</option>
                  <option value="To7Chd4Ld4UOo68GzWxq">Beach Places</option>
                  <option value="YsD4nfH3n21oW1lS9V6I">Historical Places</option>
                  <option value="tqnzPLgJvzZGg5AR0cQP">International Wedding</option>
                </select>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowDestinationModal(false)}>
              Cancel
            </Button>
            <Button variant="primary" onClick={updateDestination}>
              Update
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Category Modal */}
        <Modal
          show={showCategoryModal}
          onHide={() => setShowCategoryModal(false)}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Select Your Category</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {filteredCategory?.map((category) => {
              const isDisabled = merchant?.sub_category_id === category.id;
              const isChecked = preferences?.includes(category.id);
              return (
                <div className="form-check" key={category.id}>
                  <input
                    type="checkbox"
                    id={category.name.toLowerCase()}
                    className="form-check-input"
                    disabled={isDisabled}
                    checked={isChecked}
                    onChange={() => {
                      setPreferences((prev) =>
                        isChecked
                          ? prev.filter((id) => id !== category.id)
                          : [...prev, category.id]
                      );
                    }}
                  />
                  <label className="form-check-label" htmlFor={category.name.toLowerCase()}>
                    {category.name}
                  </label>
                </div>
              );
            })}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowCategoryModal(false)}>
              Cancel
            </Button>
            <Button variant="primary" onClick={updateCategories}>
              Update
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
};

export default Profile;